import React from 'react';
import { useTranslation } from 'react-i18next';
import SummaryCards from '../panels/SummaryCards';
import CalculatorInputs from './CalculatorInputs';
import { CalculatorSettings, RoiSummary } from '../types';

interface Props {
  settings: CalculatorSettings;
  onSettingsChange: (next: CalculatorSettings) => void;
  summary: RoiSummary;
}

const CostAvoidanceSection: React.FC<Props> = ({ settings, onSettingsChange, summary }) => {
  const { t } = useTranslation('admin');
  return (
    <section className="roi-section cost-avoidance-section">
      <h2 className="roi-section-title">{t('roiInsights.costAvoidance.title')}</h2>
      <p className="roi-section-subtitle">{t('roiInsights.costAvoidance.subtitle')}</p>
      <CalculatorInputs settings={settings} onChange={onSettingsChange} />
      <SummaryCards summary={summary} />
    </section>
  );
};

export default CostAvoidanceSection;
